import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../constants/style';
import { toREM } from '../../../../utils/generalUtils';

export const useStyles = makeStyles(theme =>
  createStyles({
    navigationLink: {
      color: STYLE.COLOR.ACCENT_PRIMARY_DARKER,
    },
  })
);
